<template>
  <StrokeButton
    plain
    size="middle"
    type="primary"
    :loading="isLoading"
    @click="getCSV"
  >
    {{ $t('EXPORT_CSV') }}
  </StrokeButton>
</template>

<script>
import { SearchAdsCampaigns } from '@/api/api';
import FileSaver from 'file-saver';

import StrokeButton from '../../common/StrokeButton';

export default {
  name: 'SearchAdsCampaignsCSVButton',
  components: {
    StrokeButton,
  },
  props: {
    range: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    getCSV() {
      this.isLoading = true;
      return SearchAdsCampaigns.saveCSV(this.range)
        .then(file => {
          FileSaver.saveAs(file, file.name);
        })
        .catch(({ message }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
